/**
 * Keen Slider registry.
 *
 * Two jobs, both for the block editor, both no-ops for visitors:
 *
 *   1. Re-entrancy. The editor re-renders a block after every field change and
 *      calls the init again; a second KeenSlider on the same element stacks
 *      instances. ccmSiteSliders() destroys what is already there first. On the
 *      front end nothing is initialised when this first runs, so the destroy
 *      loop finds nothing.
 *   2. Reachability. The editor cannot import; it needs an entry point it can
 *      call from the canvas window. Each init site registers itself here
 *      instead of running at parse time, so one call re-runs all of them.
 *
 * ccmKeenSlider() parks the instance on the element and stamps
 * `keen-slider--ready`, because Keen Slider has no ready class of its own.
 * acf-blocks-editor.css section 5 and the driver's CONFIG both key off that
 * class — change it here and you must change it in both.
 *
 * Declared first in this file so it survives even in a context where the
 * jQuery block below cannot run.
 */
(function (w) {
    var registry = [];

    function ccmRegisterSlider(fn) {
        if (typeof fn === 'function' && registry.indexOf(fn) === -1) {
            registry.push(fn);
        }
    }

    function ccmKeenSlider(el, options, plugins) {
        if (!el || typeof w.KeenSlider === 'undefined') {
            return null;
        }

        var instance = new w.KeenSlider(el, options, plugins);

        if (instance) {
            el.__keenSlider = instance;
            el.classList.add('keen-slider--ready');
        }

        return instance;
    }

    function ccmDestroySliders() {
        var els = document.querySelectorAll('.keen-slider');
        var i, el;

        for (i = 0; i < els.length; i++) {
            el = els[i];

            if (el.__keenSlider) {
                try {
                    el.__keenSlider.destroy();
                } catch (e) {
                    // A half-built instance can throw on teardown; the element
                    // still has to be released or the next init stacks on it.
                }
                el.__keenSlider = null;
            }

            el.classList.remove('keen-slider--ready');
        }
    }

    function ccmSiteSliders() {
        ccmDestroySliders();

        for (var i = 0; i < registry.length; i++) {
            try {
                registry[i]();
            } catch (e) {
                if (w.console) {
                    w.console.error('[ccmSiteSliders]', e);
                }
            }
        }
    }

    w.ccmRegisterSlider = ccmRegisterSlider;
    w.ccmKeenSlider = ccmKeenSlider;
    w.ccmSiteSliders = ccmSiteSliders;

    // No init site runs at parse time any more, so something has to start them
    // on the front end. In the editor canvas the driver calls ccmSiteSliders()
    // itself once the block scripts have registered.
    w.addEventListener('load', function () {
        ccmSiteSliders();
    });
}(window));

//doent return an error if the id doesnt exist, instead returns an empty function
Document.prototype.querySelectorSafe = function (selector) {
	let element = this.querySelector(selector);
	if (!element) {
		console.error('Element with selector ' + selector + ' does not exist.');
		return new Proxy({}, {
			get: function (target, property) {
				return function () { };
			}
		});
	}
	return element;
}

Document.prototype.getElementByIdSafe = function (id) {
	let element = this.getElementById(id);
	if (!element) {
		console.error('Element with id ' + id + ' does not exist.');
		return new Proxy({}, {
			get: function (target, property) {
				return function () { };
			}
		});
	}
	return element;
}

// Guarded so the bundle stays evaluable where jQuery is absent — the block
// editor canvas is an iframe of its own and has no jQuery. Without the guard
// the ReferenceError here aborts the rest of this file, including the slider
// helpers below. On the front end jQuery is always enqueued ahead of main.js,
// so this runs exactly as before.
if (typeof jQuery !== 'undefined') {
jQuery(document).ready(function($){
    $(".offcanvas .mobile-menu  li.menu-item-has-children").append('<span class="nav-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16.0832 13.3707C16.808 12.6006 16.808 11.3994 16.0832 10.6293L8.7282 2.81464C8.34969 2.41246 7.71681 2.39329 7.31464 2.7718C6.91246 3.15032 6.89329 3.78319 7.2718 4.18537L14.6268 12L7.2718 19.8146C6.89329 20.2168 6.91247 20.8497 7.31464 21.2282C7.71681 21.6067 8.34969 21.5875 8.7282 21.1854L16.0832 13.3707Z" fill="#0A0A0A"/></svg></span>');
    $(".offcanvas .mobile-menu li.menu-item-has-children .nav-arrow").on("click", function(e){
        e.stopPropagation();
        var parentLi = $(this).closest("li.menu-item-has-children");
        parentLi.toggleClass("active");
        if (parentLi.hasClass("active")) {
            parentLi.find('.sub-menu').first().slideDown().siblings('.sub-menu').slideDown();
        } else {
            parentLi.find('.sub-menu').slideUp().siblings('.sub-menu').slideUp();
        }
        return false;
    });

    $('.dl-btn').on('click', function(e) {
        var productTitle = $(this).data('product-title');
        var fileUrl = $(this).data('file');

        $('#field_2_8 input').val(productTitle);
        $('#field_2_11 input').val(fileUrl);
    });

    // Function to get the URL parameter
    function getQueryParam(name) {
        var urlParams = new URLSearchParams(window.location.search);
        var param = urlParams.get(name);
        return param ? decodeURIComponent(param) : null;
    }

    // Retrieve the file URL from the URL parameters
    var fileUrl = getQueryParam('fileUrl');
    if (fileUrl) {
        // Set the decoded URL to the button or link
        $('.pdf-file-handler').attr('href', fileUrl);
        $('.pdf-file-handler')[0].click(); // Trigger the click event to download the file
    }
    if (typeof $.fn.matchHeight === 'function') {
        $('.match').matchHeight();
    }
});
}

document.addEventListener('DOMContentLoaded', function () {
    var tabContents = document.querySelectorAll('.tab-content');
    var tabButtons = document.querySelectorAll('.tab-btn');
    if (tabContents.length > 0 && tabButtons.length > 0) {
        tabContents[0].classList.add('current');

        tabButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                var tab_id = this.getAttribute('data-tab');

                tabButtons.forEach(function(btn) {
                    btn.classList.remove('current');
                });

                tabContents.forEach(function(content) {
                    content.classList.remove('current');
                });

                this.classList.add('current');
                document.getElementById(tab_id).classList.add('current');
            });
        });
    }

    const menuToggle = document.querySelector('.toggle');
    const closeToggle = document.querySelector('.close-toggle');
    document.addEventListener('click', (event) => {
        if (menuToggle && menuToggle.contains(event.target)) {
            menuToggle.classList.toggle('active');
        }
        if (closeToggle && closeToggle.contains(event.target)) {
            closeToggle.classList.toggle('active');
        }
    });
});



function sliderAutoplay(slider, duration) {
    duration = duration || 2000
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
        clearTimeout(timeout)
    }
    function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
            timeout = setTimeout(() => {
            slider.next()
        }, duration)
    }
    slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
        })
        nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
    // Destroying the slider does not clear a pending timeout, so the next tick
    // called slider.next() on a torn-down instance. That already bit the front
    // end: our-customer destroys its slider when the window passes 992px.
    slider.on("destroyed", clearNextTimeout)
    // The editor driver calls this to guarantee autoplay: false in the canvas.
    slider.__ccmStopAutoplay = clearNextTimeout
}

function sliderNavigation(slider, navClasses, dotsClasses) {
    navClasses = navClasses || [];
    dotsClasses = dotsClasses || ["d-flex", "mt-4", "pt-2", "justify-content-center"];
    let wrapper, dots, arrowLeft, arrowRight

    function removeActive() {
        slider.slides.forEach((slide) => {
            slide.classList.remove("active")
        })
    }

    function addActive(idx) {
        slider.slides[idx].classList.add("active")
    }

    function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
    }

    function removeElement(elment) {
        elment.parentNode.removeChild(elment)
    }

    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft)
            removeElement(arrowRight)
            return
        }
        // create right arrow
        arrowLeft = createDiv("arrow arrow--left")
        // add html to arrow
        arrowLeft.innerHTML = `<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893L0.292893 12.2929C-0.0976315 12.6834 -0.0976315 13.3166 0.292893 13.7071L12.2929 25.7071C12.6834 26.0976 13.3166 26.0976 13.7071 25.7071C14.0976 25.3166 14.0976 24.6834 13.7071 24.2929L2.41421 13L13.7071 1.70711C14.0976 1.31658 14.0976 0.683417 13.7071 0.292893Z" fill="#3C3B70"/></svg>`;
        // add attribute
        arrowLeft.setAttribute("role", "button")
        // add style to arrow
        arrowLeft.style.cssText = `top: 40%; left: -38px;`;
        // add class to left arrow
        arrowLeft.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowLeft.addEventListener("click", () => slider.prev())

        // create right arrow
        arrowRight = createDiv("arrow arrow--right")
        // add html to arrow
        arrowRight.innerHTML = `<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071L1.70711 25.7071C1.31658 26.0976 0.683417 26.0976 0.292893 25.7071C-0.0976311 25.3166 -0.0976311 24.6834 0.292893 24.2929L11.5858 13L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#3C3B70"/></svg>`;
        // add attribute
        arrowRight.setAttribute("role", "button")
        // add style to arrow
        arrowRight.style.cssText = `top: 40%; right: -38px;`;
        // add class to left arrow
        arrowRight.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowRight.addEventListener("click", () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
        }
        wrapper = createDiv("navigation-wrapper")
        // add class to wrapper
        wrapper.classList.add(...["position-relative"])
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
    }

    function dotMarkup(remove) {
        if (remove) {
            removeElement(dots)
            return
        }
        dots = createDiv("dots")
        //   add class to dots
        dots.classList.add(...[...dotsClasses])
        slider.track.details.slides.forEach((_e, idx) => {

            var dotParent = createDiv("dot-parent");
            dotParent.classList.add("mx-1");
            var dot = createDiv("dot")
            // add class to dot
            dot.classList.add("m-1")
            dot.classList.add("mx-2")
            // add style to dot
            dot.style.background = "var(--bs-gray-500)"
            dot.style.border = "3px solid var(--bs-gray-500)"
            dot.style.borderRadius = "50%"
            dot.style.height = "13px"
            dot.style.width = "13px"
            dot.setAttribute("role", "button") // add attribute
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dotParent.appendChild(dot);
            dots.appendChild(dotParent)
        })
        wrapper.appendChild(dots)
    }

    function updateClasses() {
        var slide = slider.track.details.rel
        slide === 0
            ? arrowLeft.classList.add("arrow--disabled")
            : arrowLeft.classList.remove("arrow--disabled")
        slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add("arrow--disabled")
            : arrowRight.classList.remove("arrow--disabled")
            Array.from(dots.children).forEach(function (dotP, idx) {
                var dot = dotP.children[0];
                if(idx === slide){
                    dot.classList.add("dot--active")
                    dot.classList.add("border-primary")
                    dot.classList.add("bg-white")
                } else {
                    dot.classList.remove("dot--active")
                    dot.classList.remove("border-primary")
                    dot.classList.remove("bg-white")
                }
            })
    }

    slider.on("created", () => {
        addActive(slider.track.details.rel)
        markup()
        updateClasses()
    })
    slider.on("optionsChanged", () => {
        markup(true)
        markup()
        updateClasses()
    })
    slider.on("slideChanged", () => {
        removeActive()
        addActive(slider.track.details.rel)
        updateClasses()
    })
    slider.on("destroyed", () => {
        markup(true)
    })
}

function sliderAdaptiveHeight(slider) {
    function updateHeight() {
        slider.container.style.height = slider.slides[slider.track.details.rel].offsetHeight + "px";
    }

    slider.on("created", updateHeight)
    slider.on("slideChanged", updateHeight)
}

